import { render, staticRenderFns } from "./InfoBlockWrapper.vue?vue&type=template&id=1d6cb51c&scoped=true"
import script from "./InfoBlockWrapper.vue?vue&type=script&lang=js"
export * from "./InfoBlockWrapper.vue?vue&type=script&lang=js"
import style0 from "./InfoBlockWrapper.vue?vue&type=style&index=0&id=1d6cb51c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6cb51c",
  null
  
)

export default component.exports